<template>
  <div>
    <collapsibleItem>
      <div slot="heading">形状设置</div>
      <div slot="body">
        <div class="mb12">线条样式</div>
        <line-setting
          :lineName.sync="labelLineType"
          :lineWidth.sync="labelLineWidth"
          :lineColor.sync="labelLineColor"
        />
        <div class="mt16 mb16">面积样式</div>
        <el-radio-group v-model="radarAreaColorType.type" @change="changeRadarColorQuantity(radarAreaColorType.type)">
          <el-radio label="纯色">纯色</el-radio>
          <el-radio label="线性渐变">线性渐变</el-radio>
        </el-radio-group>
        <div v-if="radarAreaColorType.type === '纯色'">
          <color-picker :color.sync="radarAreaColorType.color" titlePosition="singleLine" />
        </div>
        <div v-if="radarAreaColorType.type !== '纯色'" class="mt16">
          <color-picker title="开始颜色" :color.sync="radarAreaColorType.startColor" titlePosition="singleLine" />
        </div>
        <div v-if="radarAreaColorType.type !== '纯色'" class="mt16">
          <color-picker title="结束颜色" :color.sync="radarAreaColorType.endColor" titlePosition="singleLine" />
        </div>
        <div class="mt16 mb16">透明度</div>
        <div class="verticallyCenter">
          <el-slider
            :show-tooltip="false"
            class="mr16 ml24 percent54 height4"
            v-model="opacity"
            :min="0"
            :step="1"
            :max="100"
          ></el-slider>
          <div class="number-input-box percent46_16">
            <single-input
              class="percent100"
              :value.sync="opacity"
              inputSuffixs="%"
              placeholder="请输入"
              :min="0"
              :step="1"
              :max="100"
            />
<!--            <el-input-->
<!--              class="percent100"-->
<!--              v-model="opacity"-->
<!--              placeholder="请输入"-->
<!--              :controls="false"-->
<!--              :min="0"-->
<!--              :step="1"-->
<!--              :max="100"-->
<!--              type="number"-->
<!--              v-inputHandle="{ this1, type: 'opacity' }"-->
<!--            >-->
<!--              <template slot="suffix">-->
<!--                <span class="suffix_text">%</span>-->
<!--              </template>-->
<!--            </el-input>-->
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">节点设置</div>
      <div slot="body" class="mt8 mb8">
        <div class="verticallyCenter">
          <span class="mr8">节点大小</span>
          <div class="number-input-box percent46_16 flex1">
            <single-input
              class="percent100"
              :value.sync="symbolSize"
              inputSuffixs="px"
              placeholder="请输入"
              :min="0"
              :step="1"
              :max="50"
            />
<!--            <el-input-->
<!--              class="percent100"-->
<!--              v-model="symbolSize"-->
<!--              placeholder="请输入"-->
<!--              :controls="false"-->
<!--              :min="0"-->
<!--              :step="1"-->
<!--              :max="50"-->
<!--              type="number"-->
<!--              v-inputHandle="{ this1, type: 'symbolSize' }"-->
<!--            >-->
<!--              <template slot="suffix">-->
<!--                <span class="suffix_text">px</span>-->
<!--              </template>-->
<!--            </el-input>-->
          </div>
        </div>
        <div class="mt16">
          <label class="font14 inlineMiddle mr8">节点样式</label>
          <el-select v-model="symbol" class="percent65_ height32" ref="">
            <el-option
              v-for="(item, index) in symbolStyleList"
              :key="index"
              :selected="symbol == item.value"
              :value="item.value"
              :label="item.title"
              >{{ item.title }}
            </el-option>
          </el-select>
          <color-picker :color.sync="itemColor" titlePosition="allInOneLine" title="填充颜色" class="mt16" />
          <color-picker :color.sync="borderColor" titlePosition="allInOneLine" title="边框颜色" class="mt16" />
          <div class="mb8 mt16">边框宽度</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="borderWidth"
              :min="0"
              :step="1"
              :max="30"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="borderWidth"
                inputSuffixs="px"
                placeholder="请输入"
                :min="0"
                :step="1"
                :max="30"
              />
<!--              <el-input-->
<!--                class="percent100"-->
<!--                v-model="borderWidth"-->
<!--                placeholder="请输入"-->
<!--                :controls="false"-->
<!--                :min="0"-->
<!--                :step="1"-->
<!--                :max="30"-->
<!--                type="number"-->
<!--                v-inputHandle="{ this1, type: 'borderWidth' }"-->
<!--              >-->
<!--                <template slot="suffix">-->
<!--                  <span class="suffix_text">px</span>-->
<!--                </template>-->
<!--              </el-input>-->
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">文本设置</div>
      <div slot="body" class="text_setting_content mb8">
        <el-checkbox v-model="showLabel">显示文本</el-checkbox>
        <div class="mt16" v-if="showLabel">
          <!-- 字体和颜色/字重和字号 -->
          <text-setting-update
              class="mb16 nextlinemt8"
              :fontColor.sync="labelFontColor"
              :fontFamily.sync="labelFontFamily"
              :fontSize.sync="labelFontSize"
              :fontWeight.sync="labelFontWeight"
              colorMode="chart"
          />
        </div>
        <div class="mt16 verticallyCenter" v-if="showLabel">
          <span class="mr16">单位</span>
          <el-input v-model="labelUnit" placeholder="请输入" class="unit-ipt"> </el-input>
        </div>
        <div class="mt16">
          <span class="">文字距离</span>
          <slider-and-input
              :value.sync="labelDistance"
              title=""
              :sliderMin="-100"
              :sliderMax="100"
              suffix="px"
          />
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "../publicData"
export default {
  mixins: [publicData],
  props: {
    seriesSettingItem: {
      type: Object
    },
    index: {
      type: Number
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      radarColorList: [],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      labelTypeList: [
        {
          title: "数据标题",
          value: "{b}"
        },
        {
          title: "百分比",
          value: "{d}%"
        },
        {
          title: "数据标题+百分比",
          value: "{b}:{d}%"
        },
        {
          title: "数值+百分比",
          value: "{c}:{d}%"
        },
        {
          title: "数据标题+数值",
          value: "{b}:{c}"
        }
      ],
      labelSelectOptions: [
        {
          label: "样式1",
          value: 1
        },
        {
          label: "样式2",
          value: 2
        }
      ],
      symbolStyleList: [
        { title: "圆形", value: "circle" },
        { title: "正方形", value: "rect" },
        { title: "圆弧方形", value: "roundRect" },
        { title: "三角形", value: "triangle" },
        { title: "金刚石", value: "diamond" },
        { title: "大头针", value: "pin" },
        { title: "箭头", value: "arrow" },
        { title: "无", value: "none" }
      ],
      radarAreaColorType: {}
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    },
    radarAreaColorType: {
      deep: true,
      handler(val, oldVal) {
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        let colorItem
        if (val.type === "线性渐变") {
          colorItem = {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: val.startColor || val.color // 0% 处的颜色
              },
              {
                offset: 1,
                color: val.endColor || val.color // 100% 处的颜色
              }
            ]
          }
        } else {
          colorItem = val.color || val.startColor
        }
        params.areaStyle.color = colorItem
        this.$changeOptionsEV(colorItem, "chartOption.series.0.data." + this.index + ".areaStyle.color", false)
      }
    }
  },
  computed: {
    getOptions: {
      get() {
        return this.$getOptions()
      }
    },
    // 线条样式
    labelLineType: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.getOptions.chartOption,
          "series.0.data." + this.index + ".lineStyle.type",
          "labelLineType",
          "solid"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".lineStyle.type", false)
      }
    },
    labelLineWidth: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.getOptions.chartOption,
          "series.0.data." + this.index + ".lineStyle.width",
          "labelLineWidth",
          4
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".lineStyle.width", false)
      }
    },
    labelLineColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.getOptions.chartOption,
          "series.0.data." + this.index + ".lineStyle.color",
          "labelLineColor",
          "#fff"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".lineStyle.color", false)
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".itemStyle.color", false)
        let legend = this.getOptions.chartOption.legend
        if (legend && legend.data && legend.data[this.index]?.itemStyle > 0) {
          legend.data[this.index].itemStyle.borderColor = newVal
        }
      }
    },
    opacity: {
      get() {
        return (
          this.checkAndSetPrimaryVal(
            this.getOptions.chartOption,
            "series.0.data." + this.index + ".areaStyle.opacity",
            "opacity",
            1
          ) * 100
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "chartOption.series.0.data." + this.index + ".areaStyle.opacity", false)
      }
    },
    symbolSize: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".symbolSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".symbolSize", false)
      }
    },
    symbol: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".symbol")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".symbol", false)
      }
    },
    itemColor: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".itemStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".itemStyle.color", false)
      }
    },
    borderColor: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".itemStyle.borderColor")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".itemStyle.borderColor", false)
      }
    },
    borderWidth: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".itemStyle.borderWidth")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".itemStyle.borderWidth", false)
      }
    },
    showLabel: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".label.show", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions.chartOption, "series.0.data." + this.index + ".label.fontFamily", "labelFontFamily", 'sans-serif')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".label.fontFamily", false)
      }
    },
    labelFontColor: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".label.color", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".label.fontWeight", false)
      }
    },
    labelFontSize: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".label.fontSize", false)
      }
    },
    labelUnit: {
      get() {
        if(this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.formatter")){
          let unit = this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.formatter")
          console.log("unit===", unit)
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            return this.seriesSettingItem.unit
          }else{
            return unit.slice(3)
          }

        }
        else if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return this.seriesSettingItem.unit
        } else {
          const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
          return this.seriesSettingItem.label.formatter.slice(start, -1)
        }
        // return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.formatter").slice(
        //   3
        // )
      },
      set(newVal) {
        this.$changeOptionsEV("{c}" + newVal, "chartOption.series.0.data." + this.index + ".label.formatter", false)
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".unit", false)
      }
    },
    labelDistance: {
      get() {
        return this.hasProperty(this.getOptions.chartOption, "series.0.data." + this.index + ".label.distance")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.data." + this.index + ".label.distance", false)
      }
    },
  },
  methods: {
    init() {
      this.initRadarColorList()
    },

    checkFormatterValue() {
      if (!this.seriesSettingItem.label.formatter) {
        this.$changeOptionsEV("{c}{valueUnit| }", "chartOption.series." + this.index + ".label.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.series." + this.index + ".label.rich",
          false
        )
      }
    },
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },

    // 初始化pieColorType
    initRadarColorList() {
      let item = this.seriesSettingItem
      let obj = {}
      if (typeof item.areaStyle.color === "string") {
        obj = {
          type: "纯色",
          color: item.areaStyle.color
        }
      } else if (item.areaStyle.color.type === "linear") {
        // 线性渐变色
        obj = {
          type: "线性渐变",
          startColor: item.areaStyle.color.colorStops[0].color,
          endColor: item.areaStyle.color.colorStops[1].color
        }
      }

      this.radarAreaColorType = obj
    },
    changeRadarColorQuantity(colorItemType) {
      if (colorItemType === "纯色") {
        this.$set(this.radarAreaColorType, "color", this.radarAreaColorType.startColor)
      } else {
        this.$set(this.radarAreaColorType, "startColor", this.radarAreaColorType.color)
        this.$set(this.radarAreaColorType, "endColor", this.radarAreaColorType.color)
      }
    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.custom-color {
  display: inline-block;
  width: calc(100% - 72px);
  vertical-align: middle;
}
.radar-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.radar-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.radar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.percent65_ {
  width: calc(100% - 65px);
}
.unit-ipt {
  flex: 1;
}
.text_setting_content/deep/ .el-input__inner:hover {
  background: var(--inputNuberHoverThemeBgColor) !important;
}
</style>
